import { render, staticRenderFns } from "./Debit.vue?vue&type=template&id=224f6c41&scoped=true&"
import script from "./Debit.vue?vue&type=script&lang=js&"
export * from "./Debit.vue?vue&type=script&lang=js&"
import style0 from "./Debit.vue?vue&type=style&index=0&id=224f6c41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f6c41",
  null
  
)

export default component.exports